import React from 'react';
import { hot } from 'react-hot-loader';
import { formatPrice } from '../../utils/string';
import { translate } from '../../utils/locale';
import s from './Price.scss';

const Price = ({ price, setup, product = false, checkout = false, cartTotal = false, selectionItem = false }) => {
	if (price[setup.currency]) price = price[setup.currency];
	const isOnSale = !!price.compareAtPrice && price.price !== price.compareAtPrice;
	let allowMarket = true;

	if (setup.unableToSendToCountry) return null;
	if (setup.statics?.globalSaleLimitedTo?.length) {
		const allowedMarkets = setup.statics.globalSaleLimitedTo.map((market) => market.value);
		if (allowedMarkets.indexOf(setup.market?.[0]) === -1) allowMarket = false;
	}
	if (setup.statics.globalSale && setup.consumerType === 'private' && allowMarket) {
		if (selectionItem) {
			return (
				<span className={[s.price, s.price__selectionItem].join(' ')}>
					{ !cartTotal && <span className={s.price_saleLabel}>{ translate(setup, 'sale') }</span> }
					<s className={s.price_oldPrice} aria-label={`Original price ${formatPrice(setup, price.price)}`}>{ formatPrice(setup, price.price) }</s>
					<span className={s.price_sale}>{ formatPrice(setup, price.price, false, false, setup.statics.globalSale) }</span>
				</span>
			);
		}

		return (
			<span className={[s.price, (product ? s.price__product : null), (checkout ? s.price__checkout : null)].join(' ')}>
				<s className={s.price_oldPrice} aria-label={`Original price ${formatPrice(setup, price.price)}`}>{ formatPrice(setup, price.price) }</s> <span className={s.price_sale}>{ formatPrice(setup, price.price, false, false, setup.statics.globalSale) }</span>
				{ !cartTotal && <span className={s.price_saleLabel}>{ translate(setup, 'sale') }</span> }
			</span>
		);
	}
	if (product) return <span className={[s.price, (isOnSale ? s.price__sale : null)].join(' ')}>{ formatPrice(setup, price.price) }</span>;
	return (
		<span className={[s.price, (product ? s.price__product : null), (checkout ? s.price__checkout : null)].join(' ')}>
			{ isOnSale ? <><s className={s.price_oldPrice} aria-label={`Original price ${formatPrice(setup, price.compareAtPrice)}`}>{ formatPrice(setup, price.compareAtPrice) }</s> <span className={s.price_sale}>{ formatPrice(setup, price.price) }</span></> : formatPrice(setup, price.price) }
		</span>
	);
};

export default hot(module)(Price);
